import React, { useState } from "react";

const EternityCoinSection = () => {
  // const [activeTab, setActiveTab] = useState("tab_general_question");
  const [activeAccordion, setActiveAccordion] = useState("collapse_1");

  // const toggleTab = (tabId) => {
  //   setActiveTab(tabId);
  // };

  const toggleAccordion = (accordionId) => {
    setActiveAccordion(accordionId === activeAccordion ? "" : accordionId);
  };

  // Array of FAQ questions
  const faqQuestions = [
    {
      question: "Eternity Coin",
      answer: "Where your TopCoin UK journey becomes unlimited.",
    },
    {
      question: "What Is the Eternity Coin?",
      answer:
        "The Eternity Coin is the elite tier that comes after the Gold Coin, reserved for customers who go beyond 20,000,000 TopCoin and complete the full Gold journey. Once you reach this level, you unlock two powerful new coin types created especially for TopCoin UK’s most dedicated users",
    },
    {
      question: "Eternity TCUK Coin",
      answer: (
        <div>
          <h6 className="fw-semibold text-dark opacity-75">
            This coin replaces the Gold Coin after you’ve reached the TopCoin cap.
            It has:
          </h6>
          <ul>
            <li>
              No upper limit, you can continue earning TopCoin beyond 20,000,000.
            </li>
            <li>Permanent status, your progress never resets or expires.</li>
            <li>Global exclusivity, only a few will ever reach this stage.</li>
          </ul>
        </div>
      ),
    },
    {
      question: "Eternity Cash Coin",
      answer: (
        <div>
          <h6 className="fw-semibold text-dark opacity-75">An additional loyalty feature available only to Eternity holders. </h6>
          <ul>
            <li>Connected to the TopCoin UK rewards structure within the TCUK system.</li>
            <li>Any benefits are loyalty-based and linked to participation within the TopCoin UK programme.</li>
            <li>Provides an enhanced reward experience as part of the TopCoin UK loyalty journey.</li>
            <li>Not an investment, not a savings product, and not guaranteed. All rewards depend on programme rules and participation.</li>
          </ul>
        </div>
      ),
    },
        {
      question: "Why This Matters:",
      answer: (
        <div>
          <h6 className="fw-semibold text-dark opacity-75">An exclusive loyalty milestone for Eternity holders, offering enhanced recognition and access to premium benefits within the TopCoin UK rewards ecosystem. </h6>
          <ol>
            <li>Extended Reward Potential – Continue unlocking loyalty benefits beyond the standard TopCoin UK reward journey.</li>
            <li>Permanent Prestige – Eternity status is lifetime and exclusive, giving you recognition within the TopCoin UK community.</li>
            <li>Enhanced Value Experience – Your TopCoin and Eternity rewards progress together through the structured TopCoin UK reward system.</li>
            <li>Premium Access – Priority entry to selected future features, partner benefits, events, and exclusive opportunities.</li>
          </ol>
        </div>
      ),
    },
  ];

  return (
    <section
      className="faq_section bg-light-subtle section_space"
      id="id_faq_section"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center  pb-5">
   <h2 className="text-theme">The Ultimate Tier - Beyond Gold</h2>
        <p className="text-dark opacity-75">At TopCoin UK, we reward true loyalty, commitment, and progress. That’s why we’re excited to introduce the final and most exclusive level in the TopCoin UK system:</p>
          </div>
        </div>
     
      </div>
      <div className="container">
        <div
          className="tab_block"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="100"
        >
          <div className="tab-content">
            {/* General Question Tab */}
           <div className="ico_accordion" id="accordion_1">
                {faqQuestions.map((item, index) => {
                  const collapseId = `collapse_${index + 1}`;
                  return (
                    <div className="accordion-item" key={collapseId}>
                      <div
                        className={`icon_arrow ${
                          activeAccordion === collapseId ? "collapsed" : ""
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        <svg
                          viewBox="0 0 23 27"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                          <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                          <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                        </svg>
                      </div>
                      <div
                        className={`accordion-button ${
                          activeAccordion === collapseId ? "" : "collapsed"
                        }`}
                        role="button"
                        onClick={() => toggleAccordion(collapseId)}
                      >
                        <h5 className="fw-semibold text-dark m-0 ">
                          {" "}
                          {`${index + 1}- ${item.question}`}
                        </h5>
                      </div>
                      <div
                        id={collapseId}
                        className={`accordion-collapse collapse ${
                          activeAccordion === collapseId ? "show" : ""
                        }`}
                        data-bs-parent="#accordion_1"
                      >
                        <div className="accordion-body">
                          <p>{item.answer}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EternityCoinSection;
